import React from 'react';
import { Mail, Info, Calendar } from 'lucide-react';
import LegalLayout, { Section } from '../components/legal/LegalLayout';

export default function Contact() {
  return (
    <LegalLayout title="Contact VelvetGate" testId="contact-page">
      <p>
        Need help? VelvetGate can assist with platform-related issues. Event-specific questions should be directed to the event Host.
      </p>

      <Section title="Platform Support">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
            <Mail className="w-4 h-4 text-[#D4AF37]" />
          </div>
          <div>
            <p>For issues with passes, access links, confirmation emails, recovery links, or technical problems, contact:</p>
            <p className="mt-1">
              <a href="mailto:admin@velvetgatepass.com" className="text-[#D4AF37] hover:underline font-semibold" data-testid="contact-email">admin@velvetgatepass.com</a>
            </p>
          </div>
        </div>
      </Section>

      <Section title="Event Questions">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
            <Calendar className="w-4 h-4 text-[#D4AF37]" />
          </div>
          <p>For questions about event rules, approval decisions, refunds, location details, dress code, arrival time, or admission, contact the event Host directly.</p>
        </div>
      </Section>

      <Section title="Important Note">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
            <Info className="w-4 h-4 text-[#D4AF37]" />
          </div>
          <p>VelvetGate is the technology platform. Event Hosts control their own events, guest approvals, payments, refunds, and admission decisions.</p>
        </div>
      </Section>

      <Section title="Response Expectation">
        <p>Please include:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Event name</li>
          <li>Email or phone number used during registration</li>
          <li>A brief description of the issue</li>
          <li>Screenshot if helpful</li>
        </ul>
      </Section>
    </LegalLayout>
  );
}
